import _ from "lodash";
import { useEffect, useState } from "react";
import withUser from "../../redux/HOC/withUser";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";

const ClientAccountSelector = ({ user, isHorizontalNav }: any) => {
  const [currentActiveAccountCode, setActiveAccountCode] = useState<any>('');
  const [currentActiveClient, setActiveClient] = useState<any>('');
  const [clientList, setClientList] = useState<any>([]);
  const [accountList, setAccountList] = useState<any>([]);
  const [isHorizontal, setIsHorizontal] = useState(isHorizontalNav);

  useEffect(() => {
    setIsHorizontal(isHorizontalNav);
  }, [isHorizontalNav]);

  useEffect(() => {
    let activeAccountCode = window.localStorage.getItem("activeAccountCode");
    let activeClient = window.localStorage.getItem("activeClient");

    if (activeAccountCode) {
      setActiveAccountCode(activeAccountCode);
    }
    if (activeClient) {
      setActiveClient(activeClient);
    }
    getClientsAndAccounts();
  }, []);

  const getClientsAndAccounts = () => {
    let clients: any[] = [];
    let accounts: any[] = [];
    let activeClient = window.localStorage.getItem("activeClient");

    user?.accessDetails?.forEach((value: any, index: any) => {
      clients.push(value?.clientName);
    });
    let accountsByClient = user?.accessDetails?.filter(
      (x: any) => x.clientName === activeClient
    );
    accountsByClient?.forEach((value: any, index: any) => {
      value?.accountDetails?.forEach((accL: any) => {
        accounts.push(accL?.accountCode);
      });
    });
    if (_.isArray(clients)) {
      setClientList(clients);
    }

    if (_.isArray(accounts)) {
      setAccountList(accounts);
    }
  };

  const onClientChange = (clientName: string) => {
    if (clientName) {
      window.localStorage.setItem("activeClient", clientName);
      setActiveClient(clientName);
      let accounts: any[] = [];
      let accountsByClient = user?.accessDetails?.filter(
        (x: any) => x.clientName === clientName
      );
      accountsByClient?.forEach((value: any, index: any) => {
        value?.accountDetails?.forEach((accL: any) => {
          accounts.push(accL?.accountCode);
        });
      });

      if (_.isArray(accounts)) {
        setAccountList(accounts);
      }
      if (accounts && accounts?.length > 0) {
        onAccountChange(accounts[0]?.accountCode);
      }
    }
  };

  const onAccountChange = (accountCode: string) => {
    if (accountCode) {
      window.localStorage.setItem("activeAccountCode", accountCode);
      setActiveAccountCode(accountCode);
      let activeClient = window.localStorage.getItem("activeClient");
      let accountsByClient = user?.accessDetails?.find(
        (x: any) => x.clientName === activeClient
      );
      if (accountsByClient) {
        let account = accountsByClient?.accountDetails?.find(
          (acc: any) => acc.accountCode === accountCode
        );
        if (account) {
          window.localStorage.setItem(
            "currentActiveAccount",
            JSON.stringify(account)
          );
        }
        window.location.reload();
      }
    }
  };

  const getVerticalClientAndAccounts = () => {
    return (
      <>
        {" "}
        {!isHorizontal && <hr className="v-nav-hr" />}
        <FormControl fullWidth>
          <InputLabel id="client-label" className="ms-3" shrink={true}>
            Client
          </InputLabel>
          <Select
            labelId="client-label"
            id="demo-simple-select"
            value={currentActiveClient}
            label="Client"
            onChange={(e: any) => onClientChange(e?.target?.value)}
            className="ms-3"
          >
            {clientList?.map((client: any, index: number) => {
              return (
                <MenuItem key={index + client} value={client}>
                  {client}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
        {!isHorizontal && <hr className="v-nav-hr" />}
        <div id="accountId">
          <FormControl fullWidth>
            <InputLabel
              id="demo-simple-select-label"
              className="ms-3"
              shrink={true}
            >
              Account
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={currentActiveAccountCode}
              label="Account"
              onChange={(e: any) => onAccountChange(e?.target?.value)}
              className="ms-3"
            >
              {accountList?.map((account: any, index: number) => {
                return (
                  <MenuItem key={index + account} value={account}>
                    {account}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </div>
      </>
    );
  };

  const getHorizontalClientAndAccount = () => {
    return (
      <>
        <div className="profileBar-logoName">
          <div className="listItem">
            {clientList?.length > 1 && (
              <div className="collapse navbar-collapse" id="clientId">
                <ul className="navbar-nav">
                  <li className="nav-item dropdown">
                    <button
                      className="btn dropdown-toggle drp-btn"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      {currentActiveClient}
                    </button>
                    <ul className="dropdown-menu drp-menu">
                      {clientList?.map((value: any, index: any) => {
                        return (
                          <li key={index}>
                            <span
                              className="dropdown-item drp-item"
                              onClick={() => {
                                onClientChange(value);
                              }}
                            >
                              {value}
                            </span>
                          </li>
                        );
                      })}
                    </ul>
                  </li>
                </ul>
              </div>
            )}
            {clientList?.length === 1 && (
              <div className="collapse navbar-collapse" id="clientId">
                <ul className="navbar-nav">
                  <li className="nav-item">
                    <button className="btn drp-btn">
                      {currentActiveClient}
                    </button>
                  </li>
                </ul>
              </div>
            )}
            {accountList?.length > 1 && (
              <div className="collapse navbar-collapse" id="accountId">
                <ul className="navbar-nav">
                  <li className="nav-item dropdown">
                    <button
                      className="btn dropdown-toggle drp-btn"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      Account: {currentActiveAccountCode}
                    </button>
                    <ul className="dropdown-menu drp-menu">
                      {accountList?.map((value: any, index: any) => {
                        return (
                          <li key={index}>
                            <span
                              className="dropdown-item drp-item"
                              onClick={() => {
                                onAccountChange(value);
                              }}
                            >
                              {value}
                            </span>
                          </li>
                        );
                      })}
                    </ul>
                  </li>
                </ul>
              </div>
            )}
            {accountList?.length === 1 && (
              <div className="collapse navbar-collapse" id="accountId">
                <ul className="navbar-nav">
                  <li className="nav-item dropdown">
                    <button className="btn drp-btn">
                      Account: {currentActiveAccountCode}
                    </button>
                  </li>
                </ul>
              </div>
            )}
          </div>
        </div>
      </>
    );
  };

  return (
    <>
      <div
        className={
          isHorizontal
            ? "mt-1 d-flex flex-row me-2"
            : "d-flex flex-column mt-auto d-flex justify-content-center"
        }
      >
        {isHorizontal
          ? getHorizontalClientAndAccount()
          : getVerticalClientAndAccounts()}
      </div>
    </>
  );
};

export default withUser(ClientAccountSelector);
